import { useContext } from "react"
import { DESC } from "helpers/sorts"
import { useFactorViewDashboardMetrics } from "helpers/metrics/hooks"
import { getPerformanceFilterInstrumentColumns } from "helpers/metrics"
import { INSTRUMENTS } from "connected-components/dashboard/helpers"
import { useTemplateGatherers } from "connected-components/dashboard/hooks/use-template-gatherers"
import ContributorsDataIntegrator from "gatherers/contributors-data-integrator"
import ContributorsTable from "renderers/contributors-datagrid"
import { useAnalytics } from "connected-components/analytics"
import { PERFORMANCE_CONTEXT } from "./context"
import { useFactorsViewTableHandlers } from "../../hooks/use-factors-view-table-handlers"
import { FACTORS_VIEW_COMMON_PROPS } from "../../prop-types"

export default function FactorsPerformanceView({ context, instrumentsWithMetadata, instrumentColumns }) {
  const { selectedMetricDisplay } = useContext(PERFORMANCE_CONTEXT)
  const { base: contextBase, sortMetricId, setSortMetricId, sortDirection, setSortDirection, selectedTableLevels, setSelectedTableLevels, period, performanceEndDate, performanceStartDate, isEndVsStartDateComparison } = useContext(context)

  const analytics = useAnalytics()
  const { handleSortChanged, handleTableNavigationChanged } = useFactorsViewTableHandlers({ track: analytics.track })

  const gatherers = useTemplateGatherers(context, "factorPerformance", {
    from: performanceStartDate,
    to: performanceEndDate,
    selectedMetricDisplay,
    useCompositionQueries: false,
  })

  const metrics = useFactorViewDashboardMetrics(
    [
      {
        category: "factorPerformance",
        selectedMetricDisplay,
        period,
        filterInstrumentColumns: getPerformanceFilterInstrumentColumns(isEndVsStartDateComparison),
      },
    ],
    { instrumentColumns, isActive: !!contextBase, instrumentsWithMetadata, isEndVsStartDateComparison },
  )

  const defaultSortSuffix = INSTRUMENTS[instrumentColumns[0]].suffix

  return <ContributorsDataIntegrator
    gatherers={gatherers}
    metrics={metrics}
    Renderer={ContributorsTable}
    rendererProps={{
      groupByName: "Category",
      defaultSort: {
        path: `cumulativeReturn${defaultSortSuffix}`,
        direction: DESC,
      },
      disableCategories: true,
      classes: "factors-table",
      idLabel: "Factor",
      hidePagination: true,
      includeDrilldownArrows: true,
      downloadKey: "factors.performance",
      downloadName: "Factors - Performance",
      sortMetricId,
      onSortMetricIdChange: setSortMetricId,
      sortDirection,
      onSortDirectionChange: setSortDirection,
      tableNavigationLevels: selectedTableLevels,
      onTableNavigationChange: setSelectedTableLevels,
      onSortChanged: handleSortChanged,
      onTableNavigationChanged: handleTableNavigationChanged,
      context,
    }}
  />
}

FactorsPerformanceView.propTypes = FACTORS_VIEW_COMMON_PROPS
